function formatPercentage(number, fractionDigits = 0) {
  return `${(number*100).toFixed(fractionDigits)}%`
}

export default formatPercentage;
